import { COUNTRY_CODES } from 'utils/countries'
import { TState } from '../types/index'

export const STATES: TState[] = [
  { name: 'Aguascalientes', code: 'AG' },
  { name: 'Baja California', code: 'BC' },
  { name: 'Baja California Sur', code: 'BS' },
  { name: 'Campeche', code: 'CM' },
  { name: 'Chiapas', code: 'CS' },
  { name: 'Chihuahua', code: 'CH' },
  { name: 'Ciudad de México', code: 'CX' },
  { name: 'Coahuila', code: 'CO' },
  { name: 'Colima', code: 'CL' },
  { name: 'Durango', code: 'DG' },
  { name: 'Guanajuato', code: 'GT' },
  { name: 'Guerrero', code: 'GR' },
  { name: 'Hidalgo', code: 'HG' },
  { name: 'Jalisco', code: 'JC' },
  { name: 'México', code: 'EM' },
  { name: 'Michoacán', code: 'MI' },
  { name: 'Morelos', code: 'MO' },
  { name: 'Nayarit', code: 'NA' },
  { name: 'Nuevo León', code: 'NL' },
  { name: 'Oaxaca', code: 'OA' },
  { name: 'Puebla', code: 'PU' },
  { name: 'Querétaro', code: 'QT' },
  { name: 'Quintana Roo', code: 'QR' },
  { name: 'San Luis Potosí', code: 'SL' },
  { name: 'Sinaloa', code: 'SI' },
  { name: 'Sonora', code: 'SO' },
  { name: 'Tabasco', code: 'TB' },
  { name: 'Tamaulipas', code: 'TM' },
  { name: 'Tlaxcala', code: 'TL' },
  { name: 'Veracruz', code: 'VE' },
  { name: 'Yucatán', code: 'YU' },
  { name: 'Zacatecas', code: 'ZA' }
]

export const US_STATES: TState[] = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'District of Columbia', code: 'DC' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: '' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Virgin Islands', code: 'VI' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' }
]

export const getStateNameByCountryAndStateCode = (country: string, stateCode: string): string => {
  let state: TState | undefined = { name: '', code: '' }
  if (country === COUNTRY_CODES.MEXICO) {
    state = STATES.find((state) => {
      return state.code === stateCode
    })
  } else if (country === COUNTRY_CODES.US) {
    state = US_STATES.find((state) => {
      return state.code === stateCode
    })
  }

  if (state) {
    return state.name
  }

  return 'Unknown state'
}

export const getStateByStateCode = (stateCode: string, countryCode = COUNTRY_CODES.MEXICO): TState | undefined => {
  if (countryCode === COUNTRY_CODES.MEXICO) {
    return STATES.find((state) => state.code === stateCode)
  }

  return US_STATES.find((state) => state.code === stateCode)
}
